import React from "react";
import CameraCore from "./CameraCore.tsx";
import "./SharedCameraLayout.css";

interface SharedCameraLayoutProps {
  children: React.ReactNode;
}

const SharedCameraLayout: React.FC<SharedCameraLayoutProps> = ({ children }) => {
  return (
    <div className="shared-camera-layout">
      {/* Shared video element that persists between route changes */}
      <div className="shared-camera-layout__video-container">
        <CameraCore 
          className="shared-camera-layout__camera"
          videoClassName="shared-camera-layout__video"
        />
      </div>
      
      {/* Route-specific overlays and controls */}
      <div className="shared-camera-layout__content">
        {children}
      </div>
    </div>
  );
};

export default SharedCameraLayout; 